var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFxs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.54 6.437c-.42.442-.763.815-.767.823c0 .009.373.386.836.827l.3.287l.493.48a5.55 5.55 0 0 0-.086 6.163c-.172.184-.45.485-.767.815l-.892.95l-.038.044c0 .008 1.423 1.397 1.555 1.508l.052.043l.806-.844l.857-.909a5.55 5.55 0 0 0 6.18.026c.381.373 1.757 1.697 1.774 1.706c.013.004 1.543-1.607 1.538-1.629a135 135 0 0 0-1.692-1.637l-.03-.03a5.55 5.55 0 0 0-.009-6.128l.767-.815q.456-.466.887-.955a54 54 0 0 0-1.602-1.53c-.013 0-.408.402-.875.9c-.33.35-.621.66-.771.81a5.55 5.55 0 0 0-6.034-.052l-.026-.026l-.3-.287l-.472-.454l-.775-.75l-.155-.154l-.754.814zM12 15.43a3.428 3.428 0 1 0 0-6.857a3.428 3.428 0 0 0 0 6.857",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxs);
export default __webpack_public_path__ + "static/media/fxs.1fd8ff2135afd0e11574ff1b1fe6d3cb.svg";
export { ForwardRef as ReactComponent };